import { z } from "zod";

/**
 * Le contrat des gestes de la regie En direct (lot Q1, taches E.3 et E.4) : le titre et le jeu de la chaine, la
 * recherche d'une categorie, et les secours (ouvrir ou fermer un stream a la main, rejouer un evenement). Re-exporte
 * par `direct.ts`. Les lectures (etat, fiche) et l'import ont leurs fichiers.
 *
 * Aucun texte de Twitch n'en sort tel quel : le serveur nettoie ce qu'il rend (`cleanText`), et ne rend jamais
 * la reponse de Twitch.
 */

/** La longueur maximale d'un titre de direct, en caracteres (points de code) : la limite de Twitch. */
export const TITRE_MAX = 140;

/** Une categorie de Twitch : son identifiant (des chiffres) et son nom. */
export const jeuChaineSchema = z.object({ id: z.string(), nom: z.string() });
export type JeuChaine = z.infer<typeof jeuChaineSchema>;

/** `GET /api/direct/chaine` : le titre de la chaine, et sa categorie (`null` si elle n'en a pas). */
export const reponseChaineSchema = z.object({
  titre: z.string(),
  jeu: jeuChaineSchema.nullable(),
});
export type ReponseChaine = z.infer<typeof reponseChaineSchema>;

/** `GET /api/direct/categories?q=` : ce qu'on cherche. Absent ou vide, la liste est vide. */
export const requeteCategoriesSchema = z.object({ q: z.string().max(500).optional() });
export type RequeteCategories = z.infer<typeof requeteCategoriesSchema>;

/** `GET /api/direct/categories?q=` : dix categories au plus. */
export const reponseCategoriesSchema = z.array(jeuChaineSchema).max(10);
export type ReponseCategories = z.infer<typeof reponseCategoriesSchema>;

/**
 * `POST /api/direct/chaine` : le nouveau titre (1 a `TITRE_MAX` caracteres une fois nettoye : le serveur juge, avec
 * `titre_trop_long`) et la categorie (`null` : elle ne change pas).
 */
export const changerChaineSchema = z.object({
  titre: z.string().min(1).max(4000),
  jeuId: z
    .string()
    .regex(/^\d{1,20}$/)
    .nullable(),
});
export type ChangerChaine = z.infer<typeof changerChaineSchema>;

/**
 * Les erreurs que ces routes ecrivent elles-memes (`error.code`) : la regie en a une phrase chacune.
 * `twitch_non_relie` : la chaine n'est pas reliee (variables absentes, compte absent ou a reautoriser).
 * `twitch_refuse` : Twitch a refuse l'appel ou ne repond pas (un droit manquant, par exemple).
 * `titre_trop_long` : plus de `TITRE_MAX` caracteres. `deja_ouvert` / `aucun_ouvert` : le secours n'a rien a faire.
 */
export const CODES_REGIE = [
  "twitch_non_relie",
  "twitch_refuse",
  "titre_trop_long",
  "deja_ouvert",
  "aucun_ouvert",
] as const;
export type CodeRegie = (typeof CODES_REGIE)[number];
